import React from "react";

import dynamic from "next/dynamic";

import Heading from "components/heading";

import HeroSection from "../../../hero-section";

const MainFigure = dynamic(() => import("./figure"));

const title = "Enerflo is THE Solar Platform";

const MainHero = () => (
  <div className="relative overflow-hidden bg-gradient-to-br from-navy-dark to-primary">
    <HeroSection title={title} className="flex-col-reverse space-y-reverse sm:flex-row">
      <HeroSection.Content className="sm:py-10 sm:pl-14 sm:pr-0 sm:w-1/2 sm:text-left">
        <HeroSection.Header className="text-white sm:justify-start md:items-start">
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description className="text-gray-200">
          Grow your solar business by providing a streamlined, end-to-end experience for your customers and employees
          with Enerflo. Seamlessly integrate the tools you know and love with industry-first features that work together
          to optimize your sales and operations.
        </HeroSection.Description>
      </HeroSection.Content>

      <div className="z-[1] pl-3 w-full xs:w-3/4 md:w-1/2 overflow-hidden sm:overflow-visible relative">
        <figure className="relative">
          <MainFigure />
        </figure>
      </div>
    </HeroSection>
  </div>
);

export default MainHero;
